import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { checkAllowedAccess } from './checkAllowedAccess.helper';

/**
 * Custom hook to determine if user has access based on their permissions
 *
 * @param {Array} permissions - List of all permissions the user has
 * @param {Array} requiredPermissionIds - List of permission IDs required for access
 * @param {boolean} isPermissionManager - Flag indicating if user is a permission manager
 * @returns {boolean} Whether the user has access
 */
export const useAllowedAccess = (requiredPermissionIds = []) => {
  const { permissions } = useSelector((s) => s.authorization);
  const canAccess = useMemo(
    () => checkAllowedAccess(permissions, requiredPermissionIds),
    [permissions, requiredPermissionIds],
  );

  return canAccess;
};

export default useAllowedAccess;
